// js
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueStripeCheckout from 'vue-stripe-checkout';
import Datetime from 'vue-datetime';
import App from './App.vue';
import router from './router';
import Loader from './components/Loader.vue';
import FormFields from './components/FormFields.vue';
import SignIn from './plugins/sign-in/sign-in';
import ConfirmDialog from './plugins/confirm-dialog/confirm-dialog';
import WarningDialog from './plugins/warning-dialog/warning-dialog';
import GlobalLoader from './plugins/global-loader/global-loader';
import LocalStorageMixin from './services/mixin.local-storage';
import DatePicker from './components/DatePicker.vue';
import RegistrantAndEvent from './components/RegistrantAndEvent.vue';
import PaymentSummary from './components/PaymentSummary.vue';
import CostSummary from './components/CostSummary.vue';
import './icons';
import './directives/select-on-click';

// css
import './assets/scss/kjk.scss';

Vue.config.productionTip = false;

// plugins
Vue.use(GlobalLoader);
Vue.use(BootstrapVue);
Vue.use(SignIn);
Vue.use(ConfirmDialog);
Vue.use(WarningDialog);
Vue.use(VueStripeCheckout, process.env.VUE_APP_STRIPE_PUBLISHABLE_API_KEY);
Vue.use(Datetime);

// components
Vue.component('Loader', Loader);
Vue.component('FormFields', FormFields);
Vue.component('DatePicker', DatePicker);
Vue.component('RegistrantAndEvent', RegistrantAndEvent);
Vue.component('PaymentSummary', PaymentSummary);
Vue.component('CostSummary', CostSummary);

new Vue({
  router,
  render: h => h(App),
  data: {
    init: {},
    session: {},
    evt: {},
    evts: [],
    orgID: null,
    hiddentEvts: LocalStorageMixin.methods.localStorageGet('hiddenEvents', []),
    user: false,
    crs: [],
  },
}).$mount('#app');
